import { useEffect, useState } from "react";
import { Platform } from "react-native";

const useIsBrowserRefresh = () => {
  const [isRefresh, setIsRefresh] = useState(false);

  useEffect(() => {
    if (Platform.OS !== "web") return;

    const navigationEntries = performance.getEntriesByType("navigation");
    if (navigationEntries.length > 0) {
      const navType = navigationEntries[0].type;
      setIsRefresh(navType === "reload");
    }
  }, []);

  return isRefresh;
};

export default useIsBrowserRefresh;
